/* =============================================================================
   Store Locator – Revell/Carrera Shopify Theme
   ============================================================================= */

   (function () {
    'use strict';
  
    const cfg = window.__storeLocatorConfig || {};
  
    // ── Real init function ──────────────────────────────────────────────────────
    // Overwrites the placeholder that was registered in the section's inline
    // script so we handle both cases:
    //   (A) store-locator.js finishes first → Maps fires callback later  ✓
    //   (B) Maps fires callback first (e.g. cached) → queue is flushed   ✓
    function registerCallback(fn) {
      var queued = window.__slMapCallbackQueue || [];
      window.initStoreLocatorMap = fn;
      if (queued.length > 0) {
        // Maps already called the placeholder → run now
        fn();
      }
    }
  
    let map = null;
    let geocoder = null;
    let infoWindow = null;
    let allStores = [];
    let activeMarkers = [];
    let userPinMarker = null;
    let activeStoreId = null;
  
    /* --------------------------------------------------------------------------
       Map Styles – subtle, modern
    -------------------------------------------------------------------------- */
    const MAP_STYLES = [
      { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
      { featureType: 'poi.park', elementType: 'geometry', stylers: [{ lightness: 20 }] },
      { featureType: 'transit.station', elementType: 'labels', stylers: [{ visibility: 'simplified' }] },
      { featureType: 'road.highway', elementType: 'geometry', stylers: [{ saturation: -50 }] },
      { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#a8d4e6' }] },
      { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ lightness: 10 }] },
    ];
  
    /* --------------------------------------------------------------------------
       Entry Point – called by Google Maps callback
    -------------------------------------------------------------------------- */
    registerCallback(async function initMap() {
      const mapEl = document.getElementById('sl-map');
      if (!mapEl) return;
  
      try {
        map = new google.maps.Map(mapEl, {
          center: { lat: cfg.defaultLat || 51.1657, lng: cfg.defaultLng || 10.4515 },
          zoom: cfg.defaultZoom || 6,
          styles: MAP_STYLES,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT },
          zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
        });
      } catch (e) {
        mapEl.innerHTML =
          '<div style="display:flex;align-items:center;justify-content:center;height:100%;padding:24px;text-align:center;color:#c0392b;background:#fdf0f0;flex-direction:column;gap:8px">' +
          '<strong>Karte konnte nicht initialisiert werden</strong>' +
          '<code style="font-size:11px;background:#fff;padding:4px 8px;border-radius:4px">' + e.message + '</code>' +
          '</div>';
        return;
      }
  
      geocoder = new google.maps.Geocoder();
      infoWindow = new google.maps.InfoWindow({ maxWidth: 260 });
  
      bindEvents();
      await loadStores();
  
      // Force resize after init – fixes grey-map when the container
      // height resolves after the map is already created
      setTimeout(function () {
        google.maps.event.trigger(map, 'resize');
      }, 200);
    });
  
    /* --------------------------------------------------------------------------
       Load Store Data
    -------------------------------------------------------------------------- */
    async function loadStores() {
      setView('loading');
      try {
        const res = await fetch(cfg.storesUrl);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        allStores = data.stores || [];
        renderAllMarkersOnMap();
        if (cfg.autoLocate) {
          autoLocate();
        } else {
          setView('hint');
        }
      } catch (e) {
        console.error('[StoreLocator] Failed to load store data:', e);
        setView('error', 'Händlerdaten konnten nicht geladen werden.<br><small>URL: ' + cfg.storesUrl + '</small>');
      }
    }
  
    /* --------------------------------------------------------------------------
       Auto-Locate on page load
    -------------------------------------------------------------------------- */
    function autoLocate() {
      if (!navigator.geolocation) {
        setView('hint');
        return;
      }
  
      setView('loading');
  
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
          geocoder.geocode({ location: latlng }, function (results, status) {
            var input = document.getElementById('sl-address');
            if (status === 'OK' && results[0] && input) {
              input.value = results[0].formatted_address;
            }
            executeSearch(latlng);
          });
        },
        function () {
          setView('hint');
        },
        { timeout: 8000 }
      );
    }
  
    /* --------------------------------------------------------------------------
       Event Bindings
    -------------------------------------------------------------------------- */
    function bindEvents() {
      const searchBtn = document.getElementById('sl-search-btn');
      const addressInput = document.getElementById('sl-address');
      const gpsBtn = document.getElementById('sl-gps-btn');
  
      if (searchBtn) searchBtn.addEventListener('click', handleSearchClick);
  
      if (addressInput) {
        addressInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSearchClick();
          }
        });
      }
  
      if (gpsBtn) gpsBtn.addEventListener('click', handleGps);
    }
  
    /* --------------------------------------------------------------------------
       Search Handlers
    -------------------------------------------------------------------------- */
    function handleSearchClick() {
      const input = document.getElementById('sl-address');
      const address = input ? input.value.trim() : '';
  
      if (!address) {
        renderAllMarkersOnMap();
        setView('hint');
        return;
      }
  
      setView('loading');
      geocoder.geocode({ address: address, region: 'DE' }, function (results, status) {
        if (status === 'OK' && results[0]) {
          executeSearch(results[0].geometry.location);
        } else {
          setView('error', 'Ort nicht gefunden. Bitte eine andere Eingabe versuchen.');
        }
      });
    }
  
    function handleGps() {
      if (!navigator.geolocation) {
        showStatus('error', 'Dein Browser unterstützt keine Standortabfrage.');
        return;
      }
  
      const btn = document.getElementById('sl-gps-btn');
      if (btn) btn.classList.add('sl-gps-btn--loading');
      setView('loading');
  
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          const latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
          geocoder.geocode({ location: latlng }, function (results, status) {
            const input = document.getElementById('sl-address');
            if (status === 'OK' && results[0] && input) {
              input.value = results[0].formatted_address;
            }
            if (btn) btn.classList.remove('sl-gps-btn--loading');
            executeSearch(latlng);
          });
        },
        function () {
          if (btn) btn.classList.remove('sl-gps-btn--loading');
          setView('error', 'Standort konnte nicht ermittelt werden. Bitte Adresse eingeben.');
        },
        { timeout: 8000 }
      );
    }
  
    /* --------------------------------------------------------------------------
       Core Search Logic
    -------------------------------------------------------------------------- */
    function executeSearch(location) {
      const radius = parseInt((document.getElementById('sl-radius') || {}).value) || 25;
      const maxResults = parseInt((document.getElementById('sl-results') || {}).value) || 10;
      const checkedBrands = Array.from(document.querySelectorAll('.sl-brand-filter:checked')).map(function (el) {
        return el.value;
      });
      const userLat = location.lat();
      const userLng = location.lng();
  
      const results = allStores
        .reduce(function (acc, store) {
          if (checkedBrands.length > 0 && !store.brands.some(function (b) { return checkedBrands.includes(b); })) {
            return acc;
          }
          const dist = haversineKm(userLat, userLng, store.lat, store.lng);
          if (dist <= radius) {
            acc.push(Object.assign({}, store, { _distance: dist }));
          }
          return acc;
        }, [])
        .sort(function (a, b) { return a._distance - b._distance; })
        .slice(0, maxResults);
  
      clearMarkers();
      placeUserPin(location);
      addMarkersForStores(results);
      fitBoundsToResults(results, location);
      renderStoreList(results);
  
      if (results.length === 0) {
        setView('no-results', 'Keine Händler im Umkreis von ' + radius + '\u202fkm gefunden.<br>Suchradius erweitern?');
        showStatus('info', '0 Händler im ' + radius + '-km-Radius gefunden.');
      } else {
        showStatus('info', results.length + ' Händler gefunden.');
      }
    }
  
    /* --------------------------------------------------------------------------
       Haversine Distance
    -------------------------------------------------------------------------- */
    function haversineKm(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var dLat = toRad(lat2 - lat1);
      var dLng = toRad(lng2 - lng1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }
  
    function toRad(deg) {
      return (deg * Math.PI) / 180;
    }
  
    /* --------------------------------------------------------------------------
       Markers
    -------------------------------------------------------------------------- */
    function markerIcon(active) {
      var fill = active ? '#feed00' : '#e30613';
      var stroke = active ? '#222' : '#a00010';
      var w = active ? 34 : 28;
      var h = active ? 48 : 40;
      var svg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" viewBox="0 0 28 40">' +
        '<path d="M14 0C6.268 0 0 6.268 0 14c0 10.5 14 26 14 26S28 24.5 28 14C28 6.268 21.732 0 14 0z" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.5"/>' +
        '<circle cx="14" cy="14" r="5.5" fill="rgba(255,255,255,0.9)"/>' +
        '</svg>';
  
      return {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(w, h),
        anchor: new google.maps.Point(w / 2, h),
      };
    }
  
    function userPinIcon() {
      var svg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">' +
        '<circle cx="11" cy="11" r="9" fill="#feed00" stroke="#e30613" stroke-width="2.5"/>' +
        '<circle cx="11" cy="11" r="4" fill="#e30613"/>' +
        '</svg>';
      return {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
        scaledSize: new google.maps.Size(22, 22),
        anchor: new google.maps.Point(11, 11),
      };
    }
  
    function placeUserPin(location) {
      if (userPinMarker) userPinMarker.setMap(null);
      userPinMarker = new google.maps.Marker({
        position: location,
        map: map,
        icon: userPinIcon(),
        title: 'Ihr Standort',
        zIndex: 1000,
      });
    }
  
    function addMarkersForStores(stores) {
      stores.forEach(function (store) {
        var marker = new google.maps.Marker({
          position: { lat: store.lat, lng: store.lng },
          map: map,
          title: store.name,
          icon: markerIcon(false),
          zIndex: 100,
        });
  
        marker._storeId = store.id;
        marker._store = store;
  
        marker.addListener('click', function () {
          activateStore(store.id, marker, true);
          openInfoWindow(store, marker);
        });
  
        activeMarkers.push(marker);
      });
    }
  
    function renderAllMarkersOnMap() {
      clearMarkers();
      if (!map || allStores.length === 0) return;
  
      allStores.forEach(function (store) {
        var marker = new google.maps.Marker({
          position: { lat: store.lat, lng: store.lng },
          map: map,
          title: store.name,
          icon: markerIcon(false),
          zIndex: 100,
        });
        marker._storeId = store.id;
        marker._store = store;
        marker.addListener('click', function () {
          openInfoWindow(store, marker);
        });
        activeMarkers.push(marker);
      });
  
    }
  
    function clearMarkers() {
      activeMarkers.forEach(function (m) { m.setMap(null); });
      activeMarkers = [];
      if (userPinMarker) { userPinMarker.setMap(null); userPinMarker = null; }
      if (infoWindow) infoWindow.close();
      activeStoreId = null;
    }
  
    function fitBoundsToResults(stores, userLocation) {
      if (!map) return;
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(userLocation);
      stores.forEach(function (s) { bounds.extend(new google.maps.LatLng(s.lat, s.lng)); });
      map.fitBounds(bounds, { padding: 60 });
      // Cap max zoom
      google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
        if (map.getZoom() > 14) map.setZoom(14);
      });
    }
  
    /* --------------------------------------------------------------------------
       InfoWindow
    -------------------------------------------------------------------------- */
    function openInfoWindow(store, marker) {
      var brandBadges = store.brands
        .map(function (b) {
          return '<span class="sl-brand-badge sl-brand-badge--' + b + '">' + capitalise(b) + '</span>';
        })
        .join('');
  
      var distStr = store._distance !== undefined
        ? '<div class="sl-info-window__distance">' + formatDist(store._distance) + '</div>'
        : '';
  
      var content =
        '<div class="sl-info-window">' +
        '<p class="sl-info-window__name">' + escHtml(store.name) + '</p>' +
        '<p class="sl-info-window__address">' +
          escHtml(store.street) + '<br>' +
          escHtml(store.zip) + ' ' + escHtml(store.city) +
        '</p>' +
        '<div class="sl-info-window__brands">' + brandBadges + '</div>' +
        distStr +
        '</div>';
  
      infoWindow.setContent(content);
      infoWindow.open(map, marker);
    }
  
    /* --------------------------------------------------------------------------
       Store List Rendering
    -------------------------------------------------------------------------- */
    function renderStoreList(stores) {
      var inner = document.getElementById('sl-list-inner');
      if (!inner) return;
  
      if (stores.length === 0) {
        inner.innerHTML = '';
        return;
      }
  
      var countEl = '<div class="sl-results-count">' + stores.length + ' Ergebnis' + (stores.length !== 1 ? 'se' : '') + '</div>';
  
      var cards = stores
        .map(function (store) {
          var brandBadges = store.brands
            .map(function (b) {
              return '<span class="sl-brand-badge sl-brand-badge--' + b + '">' + capitalise(b) + '</span>';
            })
            .join('');
  
          var phone = store.phone
            ? '<div class="sl-store-card__phone"><a href="tel:' + escHtml(store.phone) + '">' + escHtml(store.phone) + '</a></div>'
            : '';
  
          var websiteUrl = store.website && !/^https?:\/\//i.test(store.website)
            ? 'https://' + store.website
            : store.website;
          var website = websiteUrl
            ? '<a href="' + escHtml(websiteUrl) + '" class="sl-link sl-link--info" target="_blank" rel="noopener noreferrer">Website besuchen</a>'
            : '';
  
          var directionsUrl =
            'https://www.google.com/maps/dir/?api=1&destination=' +
            encodeURIComponent(store.street + ', ' + store.zip + ' ' + store.city + ', ' + store.country);
  
          var country = store.country !== 'Germany' ? '<br>' + escHtml(store.country) : '';
          var distBadge = store._distance !== undefined
            ? '<div class="sl-store-card__distance">' + formatDist(store._distance) + '</div>'
            : '';
  
          return (
            '<div class="sl-store-card"' +
            ' id="sl-card-' + store.id + '"' +
            ' data-store-id="' + store.id + '"' +
            ' data-lat="' + store.lat + '"' +
            ' data-lng="' + store.lng + '"' +
            ' role="button"' +
            ' tabindex="0"' +
            ' aria-label="' + escHtml(store.name) + '">' +
            '  <div class="sl-store-card__header">' +
            '    <div class="sl-store-card__name">' + escHtml(store.name) + '</div>' +
            '    <div class="sl-store-card__brands">' + brandBadges + '</div>' +
            '  </div>' +
            '  <div class="sl-store-card__address">' +
              escHtml(store.street) + '<br>' +
              escHtml(store.zip) + ' ' + escHtml(store.city) +
              country +
            '  </div>' +
            phone +
            '  <div class="sl-store-card__actions">' +
              website +
            '    <a href="' + directionsUrl + '" class="sl-link sl-link--directions" target="_blank" rel="noopener noreferrer">' +
            '      <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="M21.71 11.29l-9-9a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42l9 9a1 1 0 0 0 1.42 0l9-9a1 1 0 0 0 0-1.42zM13 17.59V14h-2v4H8l4-4-4-4h3V6h2v4h3l-3 3 3 3H13v.59z"/></svg>' +
            '      Wegbeschreibung' +
            '    </a>' +
            '  </div>' +
            distBadge +
            '</div>'
          );
        })
        .join('');
  
      inner.innerHTML = countEl + cards;
  
      // Attach click/keyboard handlers
      inner.querySelectorAll('.sl-store-card').forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          var id = parseInt(card.dataset.storeId);
          var lat = parseFloat(card.dataset.lat);
          var lng = parseFloat(card.dataset.lng);
          activateStore(id, null, false);
          var marker = activeMarkers.find(function (m) { return m._storeId === id; });
          if (marker) {
            openInfoWindow(marker._store, marker);
            map.panTo({ lat: lat, lng: lng });
            if (map.getZoom() < 13) map.setZoom(13);
          }
        });
  
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            card.click();
          }
        });
      });
    }
  
    /* --------------------------------------------------------------------------
       Activate / Highlight a Store (card + marker)
    -------------------------------------------------------------------------- */
    function activateStore(storeId, clickedMarker, scrollCard) {
      // Deactivate previous
      if (activeStoreId !== null) {
        var prevCard = document.getElementById('sl-card-' + activeStoreId);
        if (prevCard) prevCard.classList.remove('sl-store-card--active');
        var prevMarker = activeMarkers.find(function (m) { return m._storeId === activeStoreId; });
        if (prevMarker) {
          prevMarker.setIcon(markerIcon(false));
          prevMarker.setZIndex(100);
        }
      }
  
      activeStoreId = storeId;
  
      var card = document.getElementById('sl-card-' + storeId);
      if (card) {
        card.classList.add('sl-store-card--active');
        if (scrollCard) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
  
      var marker = clickedMarker || activeMarkers.find(function (m) { return m._storeId === storeId; });
      if (marker) {
        marker.setIcon(markerIcon(true));
        marker.setZIndex(200);
      }
    }
  
    /* --------------------------------------------------------------------------
       UI State Management
    -------------------------------------------------------------------------- */
    function setView(state, message) {
      var inner = document.getElementById('sl-list-inner');
      if (!inner) return;
  
      var iconMap = {
        loading: '<div class="sl-spinner-wrap"><div class="sl-spinner"></div></div>',
        hint: '<svg class="sl-state-view__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/></svg>',
        error: '<svg class="sl-state-view__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg>',
        'no-results': '<svg class="sl-state-view__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/></svg>',
      };
  
      var textMap = {
        loading: { title: 'Händler werden geladen\u2026', text: '' },
        hint: { title: 'Händler finden', text: 'PLZ oder Ort eingeben und auf&nbsp;»Suche« klicken.' },
        error: { title: 'Fehler', text: message || 'Ein Fehler ist aufgetreten.' },
        'no-results': { title: 'Keine Ergebnisse', text: message || 'Keine Händler gefunden.' },
      };
  
      var info = textMap[state] || textMap['hint'];
  
      inner.innerHTML =
        '<div class="sl-state-view">' +
        (iconMap[state] || '') +
        '<p class="sl-state-view__title">' + info.title + '</p>' +
        (info.text ? '<p class="sl-state-view__text">' + info.text + '</p>' : '') +
        '</div>';
    }
  
    function showStatus(type, message) {
      var el = document.getElementById('sl-status');
      if (!el) return;
      el.className = 'sl-status sl-status--' + type;
      el.textContent = message;
    }
  
    /* --------------------------------------------------------------------------
       Utilities
    -------------------------------------------------------------------------- */
    function formatDist(km) {
      if (km < 1) return '< 1\u202fkm';
      return km.toFixed(1).replace('.', ',') + '\u202fkm';
    }
  
    function capitalise(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  
    function escHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  
  })();;
  